import { createFileRoute } from '@tanstack/react-router';

import Buslines from '@/modules/buslines/pages/Buslines';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/buslines/',
)({
  head: () => ({
    meta: [{ title: 'Rotas' }],
  }),
  component: Buslines,
});
